import React from 'react';

export default ({html, className}) => {

	function udfMarkup() {
		return { __html: html };
	}

    return (
            <div className={'udf' + className} dangerouslySetInnerHTML={udfMarkup()} />
    );
};